const LanguageCode = "en";
document.body.classList.add(LanguageCode + "-body");
const Globals = {
  LanguageCode : "en",
  language_based_api:"https://ws-n.webdunia.com/json/page?lang=en&url=/",
  Desktop_language_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=en&menuType=NavigationMenu&menuId=7",
  Desktop_header_based_api: "https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=en&menuType=NavigationMenu&menuId=7",
  Desktop_footer_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=en&menuType=FooterMenu&menuId=7",
};
export default Globals;
